module.exports = __webpack_public_path__ + "img/Light Mode2_1@4x.306d312a.png";